import { useMemo } from 'react';
import SharedLibs from 'wizarding-world-web-shared';

const useApollo = (initialState) => {
  const store = useMemo(() => SharedLibs.services.api(initialState), [initialState]);
  return store;
};

export default useApollo;
